import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const gem = defineConnector({
  identifier: "gem",
  name: "Gem",
  tagLine: "Recruiting CRM",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.gem\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "x-api-key",
        value: app.secret.apiKey,
      },
      {
        name: "x-application-secret",
        value: app.config.appSecret,
      },
    ]),
  steps: [
    {
      title: "Find your Gem API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [Gem](https://www.gem.com/) and go to **Settings → Integrations → API** to generate an API key.",
        },
      ],
    },
    {
      title: "Connect your Gem account",
      items: [
        {
          kind: "markdown",
          content: "Enter your Gem instance details and API credentials.",
        },
        {
          kind: "input",
          label: "",
          placeholder: "your-appSecret",
          required: true,
          target: { kind: "configuration", field: "appSecret" },
        },
        {
          kind: "input",
          label: "Shareable Access Key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder: "Xk9t3HZbWqLp7AeGvM4sUdYjBnR2TfQxCVi81oNz",
          helperText: "The Shareable Access Key for your Integration",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.gem.com/v0/users",
  },
});
